import * as React from 'react';
import cn from 'clsx';

import { Text } from '../../../../Text';
import bank from '../../../../Icons/bank.svg';
import developer from '../../../../Icons/developer.svg';
import ensuranse from '../../../../Icons/ensuranse.svg';
import realEstate from '../../../../Icons/realEstate.svg';
import retail from '../../../../Icons/retail.svg';

import { EHeaderIcons } from '../../../types/types';
import * as styles from './styles.css';

interface IProps {
  className?: string;
  title: string;
  icon: EHeaderIcons;
}

const icons = [bank, developer, ensuranse, realEstate, retail];

export const CardHeader: React.FC<IProps> = props => {
  const iconSrc = icons[props.icon];

  return (
    <div className={cn(styles['header'], props.className)}>
      <div className={styles['icon']}>
        <img src={iconSrc} alt="" />
      </div>
      <Text size="h3" bold>
        {props.title}
      </Text>
    </div>
  );
};
